export default __webpack_public_path__ + "static/media/mood_laugh_off.0a1a3ff0.svg";